import { render } from "./brandDetails.vue?vue&type=template&id=d4db8152"
import script from "./brandDetails.vue?vue&type=script&lang=js"
export * from "./brandDetails.vue?vue&type=script&lang=js"

import "./brandDetails.vue?vue&type=style&index=0&id=d4db8152&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__